import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConfigProvider, Dropdown } from 'antd';
import { useContext } from 'react';
import { DropdownFooter } from '../DropdownFooter';
import { useStyle } from './style';
import 'antd/es/dropdown/style';

var FilterDropdown = function FilterDropdown(props) {
  var children = props.children,
      label = props.label,
      footer = props.footer,
      disabled = props.disabled,
      onVisibleChange = props.onVisibleChange,
      visible = props.visible,
      footerRender = props.footerRender,
      placement = props.placement;

  var _useContext = useContext(ConfigProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('pro-core-field-dropdown');

  var _useStyle = useStyle(prefixCls),
      wrapSSR = _useStyle.wrapSSR,
      hashId = _useStyle.hashId;

  return wrapSSR(_jsx(Dropdown, {
    disabled: disabled,
    placement: placement,
    trigger: ['click'],
    // @ts-expect-error
    visible: visible,
    open: visible,
    onVisibleChange: onVisibleChange,
    onOpenChange: onVisibleChange,
    overlay: _jsxs("div", {
      className: "".concat(prefixCls, "-overlay ").concat(hashId),
      children: [_jsx("div", {
        className: "".concat(prefixCls, "-content ").concat(hashId),
        children: children
      }), footer && _jsx(DropdownFooter, _objectSpread({
        disabled: disabled,
        footerRender: footerRender
      }, footer))]
    }),
    children: _jsx("span", {
      className: "".concat(prefixCls, "-label ").concat(hashId),
      children: label
    })
  }));
};

export { FilterDropdown };